// Facts as label and value pairs in two columns (Console D's .kv), for a side column or a list of
// facts longer than a strip holds.
import { Fragment, type ReactNode } from 'react'

/** Key and value pairs on hairlines (the mock's `.kv`): span attributes, payload figures. */
export function KV({
  items,
  label,
  className,
}: {
  items: readonly (readonly [ReactNode, ReactNode])[]
  label?: string
  className?: string
}) {
  return (
    <dl className={className ? `kv ${className}` : 'kv'} aria-label={label}>
      {items.map(([k, v], i) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: pairs keep their order
        <Fragment key={i}>
          <dt>{k}</dt>
          <dd>{v}</dd>
        </Fragment>
      ))}
    </dl>
  )
}
